import { render, staticRenderFns } from "./UserBuildingAccessModal.vue?vue&type=template&id=40a61810"
import script from "./UserBuildingAccessModal.vue?vue&type=script&lang=js"
export * from "./UserBuildingAccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports